module.exports = __webpack_public_path__ + "img/Pista_18_2.0bc061ee.png";